<template>
  <div>
    <Spin v-if="spinShow">{{$t('loading')}}</Spin>
    <div v-else>
      <div class="pbr-index-table-ul" v-if="listDataByPageSize && listDataByPageSize.length > 0" style="">
        <ul>
          <template >
            <li v-for="(item, index) in listDataByPageSize"
                :key="index" @click="gotoDetail(item)">
              <slot></slot>
              <i class="pbr-index-dot"></i>
              <span class="pbr-list-span"
                    v-for="(c, index) in columns"
                    :key="index">{{item[c]|format(that,index)}}</span>
            </li>
          </template>
        </ul>
      </div>
      <div v-else>
        <div v-if="isFocused" style="text-align: center; margin-top: 40px; color: #5e6d82;" @click="gotoAddConcerns">
          {{$t("tabs.home.addConcerns")}}
        </div>
        <Empty v-else></Empty>
      </div>
    </div>
  </div>

</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'pbrNormalList',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: function () {
        return ['title', 'time']
      }
    },
    itemClick: {
      type: Function
    },
    url: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'GET'
    },
    listKey: {
      type: String,
      default: 'list'
    },
    pageSize: {
      type: Number,
      default: 10
    },
    params: {
      Type: Object,
      default: () => {
        return {
          // params: {
          from: 'cn',
          pageNo: 1,
          pageSize: 15
          // }
        }
      }
    },
    goto: {
      type: String
    },
    isFocused: {
      type: Boolean,
      default: false
    },
     // 是否是招标项目
     isBidding: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      that: this,
      spinShow:true,
      listData: [...this.data]
    }
  },
  computed: {
    listDataByPageSize () {
      return this.listData && this.listData.length ? this.listData.slice(0, this.pageSize) : []
    }
  },
  methods: {
    generateError(content){
      //this.$iMessage.error({content: content, duration: 5})
    },
    showError: debounce(function (content){
      //注意此处的function不能用箭头函数代替
      this.generateError(content)
    }, 1000),
    loadData () {
      let self = this
      self.spinShow = true;
      // this.$pbrAxios.get(self.url, self.params)
      this.$pbrApis.requestByUrl(this.url, self.params, this.method).then((res) => {
        if (!res) {
          // this.showError(`${this.url} 获取列表失败`)
          // this.$iMessage.error({content: `${this.url} 获取列表失败`, duration: 5})
        } else if (res.code === 200) {
          console.log(self.url, res.result[self.listKey])
          self.spinShow = false;
          self.listData = self.listKey ? res.result[self.listKey] : res.result
        } else {
          self.listData = []
          //this.$iMessage.error({content: `${this.url} ${res.message}`, duration: 5})
        }
      }).catch(error => {
        //this.$iMessage.error({content: `${this.url} ${error.message}`, duration: 5})
        self.listData = []
      }).finally(() => {
        self.spinShow = false
      })
    },
    gotoDetail (detail) {
      if (this.itemClick) {
        this.itemClick(detail)
      } else if (this.goto) {
        // let NewPage = '_empty' + '?t=' + new Date().getTime() / 1000 // 定义一个空页面
        // this.$router.push(NewPage)
        // this.$router.go(-1)
        let params=detail.keywords? {...detail,category:detail.keywords} :{...detail,category:detail.typeName}

        this.$router.push({name: this.goto,
          params: params,
          query: {
            key: detail.id,
            isBidding:this.isBidding,
            t: new Date().getTime() / 1000 // 时间戳，刷新当前router
          }})
      }
    },

    gotoAddConcerns () {
      this.$emit("open")
    },
  },
  watch: {
    data: {
      handler(newV, oldV){
        if (newV.length >= 0) {
          this.spinShow = false
          this.listData = newV
        }
        // if(newV.length == 0){
        //   this.spinShow = false
        // }
      },
      immediate: true
    },
    url: {
      handler (newV, oldV) {
        if (newV.trim().length > 0) {
          this.loadData()
        }
      },
      immediate: true
    }
  },
  filters: {
    format: function (value, that,index) {
      if (that.$moment(value).isValid() && index > 0) {
        return that.$moment(value).format('yyyy-MM-DD')
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
  .pbr-index-table-ul{
    margin: 4px 0 40px 0;
  }
  .pbr-index-table-ul span:last-child{
    margin-left: 10px;
  }
.pbr-list-empty {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pbr-list-span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-nums;
}
</style>
